import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { playClick, playSuccess } from '../utils/SoundManager';
import { VerifiedBadge, isPremiumMember } from '../components/VerifiedBadge';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function FavoritesPage() {
  const navigate = useNavigate();
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);

  const getHeaders = () => {
    const uid = localStorage.getItem('userId');
    return uid ? { 'X-User-Id': uid } : {};
  };

  useEffect(() => {
    fetchFavorites();
  }, []);

  const fetchFavorites = async () => {
    try {
      const r = await axios.get(`${BACKEND_URL}/api/favorites/list`, {
        withCredentials: true, headers: getHeaders()
      });
      setFavorites(r.data.favorites || []);
    } catch (e) {
      console.error('Failed to load favorites', e);
    } finally {
      setLoading(false);
    }
  };

  const removeFavorite = async (userId) => {
    playClick();
    try {
      await axios.post(`${BACKEND_URL}/api/favorites/remove`, { user_id: userId }, {
        withCredentials: true, headers: getHeaders()
      });
      setFavorites(prev => prev.filter(f => f.user_id !== userId));
      playSuccess();
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--light-bg)' }}>
      <div className="header">
        <div className="header-content">
          <h1 className="logo" onClick={() => navigate('/dashboard')} style={{ cursor: 'pointer' }}>وِداد</h1>
          <button className="nav-link" onClick={() => navigate('/dashboard')} data-testid="favorites-back-btn">
            ← الرئيسية
          </button>
        </div>
      </div>

      <div className="container" style={{ paddingTop: '30px', paddingBottom: '60px', maxWidth: '780px' }}>
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <div style={{ fontSize: '54px', marginBottom: '8px' }}>⭐</div>
          <h1 style={{ fontSize: '26px', color: 'var(--text-dark)', marginBottom: '6px' }}>
            قائمة الاهتمام
          </h1>
          <p style={{ color: 'var(--text-light)', fontSize: '14px' }}>
            الأعضاء الذين أضفتهم إلى المفضلة
          </p>
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <div className="floating" style={{ fontSize: '36px' }}>⏳</div>
          </div>
        ) : favorites.length === 0 ? (
          <div className="card" style={{ textAlign: 'center', padding: '50px 20px', borderRadius: '20px' }}>
            <div style={{ fontSize: '60px', marginBottom: '14px', opacity: 0.5 }}>💔</div>
            <h3 style={{ color: 'var(--text-dark)', marginBottom: '8px' }}>قائمتك فارغة</h3>
            <p style={{ color: 'var(--text-light)', fontSize: '14px', marginBottom: '20px' }}>
              ابدأ بإضافة الأعضاء الذين يهمونك من خلال زر القلب ⭐ في ملفاتهم
            </p>
            <button className="btn btn-primary" onClick={() => navigate('/search')}>
              ابحث الآن
            </button>
          </div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '14px' }}>
            {favorites.map(f => (
              <div
                key={f.user_id}
                data-testid={`favorite-item-${f.user_id}`}
                className="card profile-card"
                style={{ padding: '18px', borderRadius: '16px', position: 'relative' }}
              >
                <button
                  data-testid={`remove-fav-${f.user_id}`}
                  onClick={() => removeFavorite(f.user_id)}
                  style={{
                    position: 'absolute', top: '12px', left: '12px',
                    background: 'rgba(255, 87, 87, 0.12)', border: 'none', borderRadius: '50%',
                    width: '32px', height: '32px', cursor: 'pointer', fontSize: '16px',
                    display: 'flex', alignItems: 'center', justifyContent: 'center'
                  }}
                  title="إزالة من المفضلة"
                >
                  ❌
                </button>

                <div onClick={() => navigate(`/profile/${f.user_id}`)} style={{ cursor: 'pointer' }}>
                  <div style={{
                    width: '64px', height: '64px', borderRadius: '50%',
                    background: 'linear-gradient(135deg, var(--primary), var(--purple))',
                    margin: '0 auto 12px', display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: 'white', fontSize: '26px', fontWeight: '700'
                  }}>
                    {f.name?.charAt(0) || '👤'}
                  </div>
                  <h4 style={{
                    margin: 0, fontSize: '16px', color: 'var(--text-dark)', textAlign: 'center',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', flexWrap: 'wrap'
                  }}>
                    <span>{f.name}</span>
                    {isPremiumMember(f) && <VerifiedBadge size="sm" />}
                  </h4>
                  <p style={{ textAlign: 'center', color: 'var(--text-light)', fontSize: '13px', marginTop: '4px' }}>
                    {f.age ? `${f.age} سنة` : ''}
                    {f.city ? ` · ${f.city}` : ''}
                  </p>
                  {f.job && (
                    <p style={{ textAlign: 'center', fontSize: '12px', color: 'var(--primary)', marginTop: '4px' }}>
                      💼 {f.job}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default FavoritesPage;
